import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfOdontogramas } from '@/modules/Configuracion/interfaces'
export class OdontogramaService extends BaseService<IConfOdontogramas> {
  constructor () {
    super({
      baseUrl: 'system/odontogram/'
    })
  }
}
